import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import { store } from './reducer';

const ActionsButtons = () => {
  const { state, dispatch } = useContext(store);

  const handleOpenAddDialog = () => {
    dispatch({ type: 'OPEN_DIALOG' });
  };

  return (
    <Button
      onClick={handleOpenAddDialog}
      variant="contained"
      color="secondary"
      endIcon={<AddIcon />}
    >
      افزودن
    </Button>
  );
};

export default React.memo(ActionsButtons);
